<div class="content-wrapper ">
    <div class="form-container">
        <div class="col-sm-12 mx-auto form-wrapper" style="display: inline-block;">

            <div class="row">
                <!-- <div class="col-sm-12 col-md-6" *ngIf="reqExams">
                    <form #login="ngForm" name="getflags" (ngSubmit)="searchClicked()" class="search-flags-form">
                        <div class="row">
                            <ngx-select-dropdown *ngIf="reqExams" class="col-sm-12 col-md-9"
                                (change)="selectionChanged($event)" [multiple]="false" [config]="config"
                                [options]="reqExams"></ngx-select-dropdown>
                            <button type="submit" class="btn btn-primary form-control col-sm-12 col-md-3"
                                [disabled]="!filled()">Search</button>
                        </div>
                    </form>
                </div> -->
                <div class="col-sm-12 col-md-3">
                    <div class="row">
                        <select class="col-sm-12 col-md-8 form-control ml-4 mr-2 form-select" id="flagfilter"
                            (change)="flagFilterSelectionChanged($event)" [multiple]="false">
                            <option value="" disabled [defaultSelected]="true">Select Flag Filter</option>
                            <option value="">None</option>
                            <option value="ai">AI Flags</option>
                            <option value="human">Human Flags</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 ml-auto">
                    <!-- <app-logout style="float: right;"></app-logout> -->
                </div>
            </div>

        </div>

    </div>

    <div class="row">
        <div class="col-md-2 mx-auto">
            <div id="candidates_list_div"
                [ngStyle]="{visibility: !this.candidateNos || this.candidateNos.length == 0 ? 'hidden' : 'unset'}">
                <div *ngFor="let _candidateno of candidateNos"><button class="candidate-videos-link btn mb-1"
                        [ngClass]="{'btn-info': _candidateno != this.candidateexamno, 'btn-success': _candidateno == this.candidateexamno}"
                        (click)="loadCandidateData(this.examid,  _candidateno)">{{_candidateno}}</button></div>
            </div>
        </div>
        <div class="col-md-10 mx-auto">
            <div class="search-result">
                <div class="col-sm-12 col-sm-offset-1 mx-auto">
                    <p class="search-result-count text-center" *ngIf="(flags.size == 0 || !flags) && this.candidateexamno">No record found!</p>
                    <div  *ngIf="flags.size > 0 ">
                        <pagination-controls class="m-0 p-0" (pageChange)="getPage(p = $event)" 
                            style="text-align: left; float: left;"></pagination-controls>
                        <!-- <div style="float: right !important;">
                            <input type="text" placeholder="Candidate Exam No." [(ngModel)]="this.candidateexamno"
                                (keydown.enter)="this.searchByExamID()">
                            <button type="button" class="btn btn-outline-dark"
                                (click)="this.searchByExamID()">Search</button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="search-result p-1" *ngIf="flags.size > 0 else noCandidateVideosFound;">

                <div id="videos_grid_div" class="search-result">

                    <div class="col-sm-12 col-sm-offset-1 mx-auto">

                        <p class="search-result-count">Showing {{tabledata.size}} {{tabledata.size > 1 ? "candidates" :
                            "candidate"}}</p>

                        <div class="table-responsive proctor-monitor-table-container">

                            <table id="tabledata" datatable [dtOptions]="dtOptions" class="table proctor-monitor-table"
                                style="width: 100%;">
                                <thead>
                                    <tr>
                                        <th>S No.</th>
                                        <th>Candidate Number.</th>
                                        <th colspan=2>Flags</th>
                                        <th>Recordings</th>
                                        <th>Review Comments</th>
                                        <th>Un-Flagged</th>
                                        <th>AI Flagged</th>
                                        <th>Save</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container
                                        *ngFor="let candidateflags of tabledata | keyvalue: asIsOrder; let i = index">
                                        <ng-container
                                            *ngFor="let flag of candidateflags.value | paginate: {  itemsPerPage: itemsPerPage , currentPage: p, totalItems: totalItems}; ; first as isFirst">
                                            <tr *ngIf="isFirst">
                                                <td scope="row"><b>{{(i + 1)}}</b></td>
                                                <td><b>{{candidateflags.key}}</b></td>
                                                <td>{{flag.reason}}</td>
                                                <td>{{flag.datetimestring}}</td>
                                                <td><a class="play-video" (click)="openRecording(candidateflags,flag.flagtime)">View Recordings</a></td>
                                                <td><textarea style="width: 100%; min-width: 200px; padding:3px"
                                                        [(ngModel)]="candidateflags.value[0].reviewcomments"
                                                        [ngModelOptions]="{standalone: true}"></textarea><span
                                                        style="display: none;">{{candidateflags.value[0].reviewcomments}}</span>
                                                </td>
                                                <td><input type="checkbox" style="width: 100%;"
                                                        [(ngModel)]="candidateflags.value[0].unflag"
                                                        [ngModelOptions]="{standalone: true}"><span
                                                        style="display: none;">{{candidateflags.value[0].unflag}}</span>
                                                </td>
                                                <td><input type="checkbox" disabled style="width: 100%;"
                                                        onclick="return false;"
                                                        [ngModel]="candidateflags.value[0].aiflagged"
                                                        [ngModelOptions]="{standalone: true}"><span
                                                        style="display: none;">{{candidateflags.value[0].aiflagged}}</span>
                                                </td>
                                                <td><button
                                                        (click)="updateProcteeFlag(candidateflags.value[0].examid, candidateflags.key, candidateflags.value[0].reviewcomments, candidateflags.value[0].unflag,candidateflags.value[0].flagID)"
                                                        class="btn btn-primary" [disabled]="updatingflag">Save</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="!isFirst">
                                                <td scope="row"></td>
                                                <td></td>
                                                <td>{{flag.reason}}</td>
                                                <td>{{flag.datetimestring}}</td>
                                                <td><a [routerLink]="'/exams/'+this.examid+'/recordings'"
                                                        [queryParams]="{candidateno: candidateflags.key, examid: candidateflags.value[0].examid,flagtime:flag.flagtime}">View
                                                        Recordings</a></td>
                                                <td></td>
                                                <td></td>
                                                <td><input type="checkbox" disabled style="width: 100%;"
                                                        onclick="return false;"
                                                        [ngModel]="candidateflags.value[0].aiflagged"
                                                        [ngModelOptions]="{standalone: true}"><span
                                                        style="display: none;">{{candidateflags.value[0].aiflagged}}</span>
                                                </td>
                                                <td></td>
                                            </tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <ng-template #noCandidateVideosFound>
                    <div *ngIf="this.candidateexamno" id="no-candidate-video-div">No flag found for
                        {{this.candidateexamno}}
                    </div>
                    <div *ngIf="!this.candidateexamno" id="no-candidate-video-div">No Candidate Exam No. Selected
                    </div>
                </ng-template>
    </div>

</div>